import {isMobileApp} from "@common/utils/app/appUtils"
export function convertPath(path) {
  return (isMobileApp() ? process.env.ADIC_MAPP_BASE_PATH : process.env.ADIC_MOBILE_BASE_PATH) + path;
}

export function convertHttpUrl(url) {
  if (!url) return '';
  return url.includes('localhost') ? url : url.replace("http:", "https:");
}
